import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BusFront, HandCoins, MapPinned } from "lucide-react";

const PUBLIC_SERVICES = [
    {
        title: "Transport / Vehicle Hire",
        description:
            "Plan your trip, get a distance-based estimate, and choose from available LMCS vehicles.",
        action: "Book a vehicle",
        href: "https://dashboard.lmcsnigltd.org.ng/transport",
        icon: BusFront,
        featured: true,
        label: "Now available",
    },
    {
        title: "Land Acquisition",
        description:
            "Explore LMCS land programmes and submit your interest with flexible payment options.",
        action: "Explore land",
        href: "https://dashboard.lmcsnigltd.org.ng/public/land-aquisition-program",
        icon: MapPinned,
        label: "Open to everyone",
    },
    {
        title: "Beneficiary Withdrawal",
        description:
            "Start a secure claim for the savings of a deceased LMCS member as a named beneficiary.",
        action: "Start a claim",
        href: "/beneficiary-withdrawal",
        icon: HandCoins,
        label: "Beneficiary support",
        internal: true,
    },
];

function ServiceAction({ service }) {
    const content = (
        <>
            <span>{service.action}</span>
            <ArrowRight aria-hidden="true" size={18} strokeWidth={2} />
        </>
    );

    if (service.internal) {
        return (
            <Link className="public-service-action" to={service.href}>
                {content}
            </Link>
        );
    }

    return (
        <a className="public-service-action" href={service.href}>
            {content}
        </a>
    );
}

function NonMemberServices() {
    return (
        <section id="non-member-services" aria-labelledby="public-services-title">
            <div className="container">
                <div className="public-services-heading">
                    <p className="public-services-eyebrow">LMCS public services</p>
                    <h2 id="public-services-title">Services open to everyone</h2>
                    <p className="public-services-intro">
                        You do not need an LMCS membership to use these services.
                    </p>
                </div>

                <div className="public-services-grid">
                    {PUBLIC_SERVICES.map((service) => {
                        const Icon = service.icon;

                        return (
                            <article
                                className={`public-service ${service.featured ? "public-service-featured" : ""}`}
                                key={service.title}
                            >
                                <div className="public-service-topline">
                                    <span className="public-service-icon" aria-hidden="true">
                                        <Icon size={25} strokeWidth={1.8} />
                                    </span>
                                    <span className="public-service-label">{service.label}</span>
                                </div>
                                <div className="public-service-copy">
                                    <h3>{service.title}</h3>
                                    <p>{service.description}</p>
                                </div>
                                <ServiceAction service={service} />
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

export default NonMemberServices;
